<template>
    <modal ref="modal">
        <div class="modal-designs">
            <design
                v-bind:identifier="design"
                v-for="design in designs"
                v-bind:key="design"
                v-on:selected="design => designSelected(design, true)"
            />
        </div>
    </modal>
</template>

<style scoped>
.modal {
    white-space: normal;
}
</style>

<script>
import { modalMixin } from "ripe-commons-pluginus";

export const DesignModal = {
    name: "design-modal",
    mixins: [modalMixin],
    props: {
        designs: {
            type: Array,
            required: true
        }
    },
    mounted: function() {
        this.$bus.bind("show_designs_modal", this.showModal);
    },
    methods: {
        designSelected(design) {
            this.$bus.trigger("design_selected", design);
            this.hideModal();
        }
    }
};

export default DesignModal;
</script>
